import React from 'react'
import { Box, Typography, Divider } from '@mui/material'

/**
 * InstructionPartsTitle
 *
 * @param __namedParameters { title: string }
 * @returns JSX.Element
 * @category ReactComponents
 */
export const InstructionPartsTitle: React.FC<{ title: string }> = ({ title = '' }) => (
  <>
    <Box paddingX={4} paddingTop={4} paddingBottom={2}>
      <Typography
        component="h4"
        color={'#000'}
        fontSize={'16px'}
        fontFamily={'Roboto'}
        fontWeight={'500'}
        lineHeight={'24px'}
        letterSpacing={'0.15px'}
        textAlign={'left'}
      >
        {title}
      </Typography>
    </Box>
    <Divider />
  </>
)
